import { useState, useCallback, useEffect } from 'react';

export const useGetCharData = (
  data: any,
  commonParams: any,
  sorts: any,
  chartType = 'bar',
) => {
  const [legendData, setLegendData] = useState<Array<any>>([]);
  const [chartData, setChartData] = useState<Array<any>>([]);
  const [timeData, setTimeData] = useState<Array<any>>([]);
  const [axisTimeType, setAxisTimeType] = useState('');

  const getCharData = useCallback(() => {
    if (data?.length > 0) {
      let needTime: string;
      if (JSON.stringify(commonParams) !== '{}') {
        needTime = ['daily', 'weekly'].includes(commonParams.date_type)
          ? 'days'
          : commonParams.date_type === 'hourly'
          ? 'hourly'
          : 'year';
        setAxisTimeType(needTime);
      }
      const obj: any = {};
      data?.forEach((v: any) => {
        obj[v.edition_unified_id] = [];
      });
      data?.forEach((v: any) => {
        obj[v.edition_unified_id].push({
          value: v.value,
          axisTimeType: needTime,
          rate: v.rate,
        });
      });
      const newArr: Array<any> = [];
      const newLegendData: Array<any> = [];
      Object.keys(obj).forEach((v, index) => {
        const item: any = {
          name: v,
          type: chartType,
          data: obj[v],
        };
        if (chartType === 'bar') {
          item.stack = 'total';
        }
        newArr.push(item);
        newLegendData.push(v);
      });

      let hasOthers = newLegendData.indexOf('others');
      if (hasOthers != -1) {
        newLegendData.splice(hasOthers, 1);
        newLegendData.push('others');
      }
      const timeArr: Array<any> = [];
      data?.map((v: any) => timeArr.push(v?.time));
      const distanceArr = [...new Set(timeArr)]; //x轴时间
      newLegendData?.sort((a, b) => sorts?.indexOf(a) - sorts?.indexOf(b));
      setChartData(newArr);
      setLegendData(newLegendData);
      setTimeData(distanceArr);
    }
  }, [data, commonParams, chartType]);

  useEffect(() => {
    getCharData();
  }, [getCharData]);

  return {
    chartData,
    timeData,
    legendData,
    axisTimeType,
  };
};
